import { Shape } from '../types';
import { Ellipse, Circle, Rect, Image, Line, Path, Group, Polygon, Polyline, Text, HTML } from '../display-objects';
/**
 * canvas.customElements
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry
 */

var CustomElementRegistry =
/** @class */
function () {
  function CustomElementRegistry() {
    this.registry = {};
    this.define(Shape.CIRCLE, Circle);
    this.define(Shape.ELLIPSE, Ellipse);
    this.define(Shape.RECT, Rect);
    this.define(Shape.IMAGE, Image);
    this.define(Shape.LINE, Line);
    this.define(Shape.GROUP, Group);
    this.define(Shape.PATH, Path);
    this.define(Shape.POLYGON, Polygon);
    this.define(Shape.POLYLINE, Polyline);
    this.define(Shape.TEXT, Text);
    this.define(Shape.HTML, HTML);
  }

  CustomElementRegistry.prototype.define = function (name, constructor) {
    this.registry[name] = constructor;
  };
  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/get
   */


  CustomElementRegistry.prototype.get = function (name) {
    return this.registry[name];
  };

  return CustomElementRegistry;
}();

export { CustomElementRegistry };